import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-diff-btw-ux-ui',
  templateUrl: './diff-btw-ux-ui.component.html',
  styleUrls: ['./diff-btw-ux-ui.component.scss']
})
export class DiffBtwUxUiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
